import React from 'react';
import { IconProps } from 'src/assets/icons/types';

const Download: React.FC<IconProps> = props => {
  const { size = 20, fillColor = '#0276FE' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99992 16.6666C4.54159 16.6666 4.14936 16.5035 3.82325 16.1774C3.49659 15.8508 3.33325 15.4583 3.33325 14.9999V12.4999H4.99992V14.9999H14.9999V12.4999H16.6666V14.9999C16.6666 15.4583 16.5035 15.8508 16.1774 16.1774C15.8508 16.5035 15.4583 16.6666 14.9999 16.6666H4.99992ZM9.99992 13.3333L5.83325 9.16658L6.99992 7.95825L9.16658 10.1249V3.33325H10.8333V10.1249L12.9999 7.95825L14.1666 9.16658L9.99992 13.3333Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default Download;
